import React, { Component } from 'react';
import Utils from '../../../common/utils/Utils';

// import PropTypes from 'prop-types';
// import FeatureAttentionTableCell from './FeatureAttentionTableCell';

class FeatureAttentionTable extends Component {

  render() {

    const data = this.props.data;
    const list = this.props.data.feature_tag_list;
    const filter = this.props.filter;
    const filterSuffix = filter === 'panelist_viewed_percent' ? '%' : 's';
    return (
      <table className="table study">
        <tbody><tr>
          <td></td>
          {data.data.map((item, index) => {
            return (
              <td key={index} colSpan="2">{item.stim_name}</td>
            );
          })}

        </tr>
          <tr>
            <td></td>
            {data.data.map((item1, index) => {
              return ([
                <td key={2 + index + item1}>Feature</td>,
                <td key={1 + index + item1}>Norm</td>
              ]);
            })}
          </tr>
          {list.map((item, index) => {
            return (
              <tr key={index}>
                <td>{Utils.Capitalize(item)}</td>
                {data.data.map((item1, index) => {
                  const decimalPlace = filterSuffix === 's' ? 1 : 0;
                  const isBetterThanNorm = item1.feature_data[item][filter].toFixed(decimalPlace) > item1.norm_data[item][filter].toFixed(decimalPlace);
                  const isEqual = item1.feature_data[item][filter].toFixed(decimalPlace) === item1.norm_data[item][filter].toFixed(decimalPlace);
                  return ([
                    <td className={isBetterThanNorm ? 'green': isEqual ? 'none' : 'red'} key={1 + index + item1}>{Number(item1.feature_data[item][filter]).toFixed(decimalPlace).toLocaleString()}{filterSuffix}</td>,
                    <td key={2 + index + item1}>{Number(item1.norm_data[item][filter]).toFixed(decimalPlace).toLocaleString()}{filterSuffix}</td>

                  ]);
                })}
              </tr>
            );
          })}
        </tbody></table>
    );
  }
}

export default FeatureAttentionTable;

FeatureAttentionTable.propTypes = {
};

